import { render, staticRenderFns } from "./notFinished.vue?vue&type=template&id=70cfbba1"
import script from "./notFinished.vue?vue&type=script&lang=js"
export * from "./notFinished.vue?vue&type=script&lang=js"
import style0 from "./notFinished.vue?vue&type=style&index=0&id=70cfbba1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports